import { useLocation } from "react-router";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../stores/hooks/hooks.ts";
import { signOutUser } from "../../../../stores/thunks/userAuthThunk.tsx";
import { RevProfileMenuShell, RevLink } from "@revmatics/catalyst";

export const ProfileMenu = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const profile = useAppSelector((state) => state.profile.profile);

  const isOnboarding = location.pathname.startsWith("/onboarding");

  const handleLogout = () => {
    dispatch(signOutUser());
  };

  if (!profile) return null;

  return (
    <RevProfileMenuShell
      profile={{
        first_name: profile.first_name,
        last_name: profile.last_name,
        email: profile.email,
        profile_picture: profile.profile_picture,
      }}
      manageAccountLink={
        !isOnboarding ? (
          <RevLink
            pathname="/profile-settings"
            buttonVariant="primary"
            buttonSize="medium"
            displayAs="button"
            buttonColor="primary"
            local
            text="Manage account"
          />
        ) : undefined
      }
      onLogout={handleLogout}
    />
  );
};
